import { Link as RouterLink } from 'react-router-dom'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#0B2027',
        color: 'rgba(255,255,255,0.85)',
        pt: 7,
        pb: 4,
        mt: 'auto',
        borderTop: '1px solid rgba(255,255,255,0.08)',
      }}
    >
      <Box sx={{ maxWidth: 1200, mx: 'auto', px: { xs: 3, md: 4 } }}>
        <Grid container spacing={{ xs: 4, md: 6 }}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
              <Box sx={{ width: 22, height: 22, borderRadius: '50%', border: '3px solid #B87333', flexShrink: 0 }} />
              <Typography
                variant="h6"
                sx={{
                  fontFamily: '"Space Grotesk", "Helvetica Neue", sans-serif',
                  fontWeight: 600,
                  color: '#B87333',
                  fontSize: '1rem',
                }}
              >
                Future of Farm Food Library
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.65)', lineHeight: 1.7, fontWeight: 700 }}>
              Supporting the transition to regenerative agriculture in South Africa
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Typography
              variant="overline"
              sx={{
                color: '#8A9A5B',
                letterSpacing: '0.2em',
                display: 'block',
                mb: 1.5,
              }}
            >
              Navigate
            </Typography>
            {[
              { label: 'Why It Matters', to: '/benefits' },
              { label: 'Research Library', to: '/research' },
              { label: 'Directory', to: '/directory' },
              { label: 'About', to: '/about' },
              { label: 'Submit Organisation', to: '/submit' },
            ].map((link) => (
              <Link
                key={link.to}
                component={RouterLink}
                to={link.to}
                underline="hover"
              sx={{
                display: 'block',
                color: 'rgba(255,255,255,0.7)',
                fontSize: '0.875rem',
                fontWeight: 700,
                mb: 0.5,
                transition: 'color 0.2s ease',
                '&:hover': { color: '#B87333' },
              }}
            >
              {link.label}
            </Link>
          ))}
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Typography
              variant="overline"
              sx={{
                color: '#8A9A5B',
                letterSpacing: '0.2em',
                display: 'block',
                mb: 1.5,
              }}
            >
              Supported by
            </Typography>
            <Link
              href="https://africanclimate.org"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              sx={{
                display: 'block',
                color: 'rgba(255,255,255,0.7)',
                fontSize: '0.875rem',
                fontWeight: 700,
                mb: 1,
                transition: 'color 0.2s ease',
                '&:hover': { color: '#B87333' },
              }}
            >
              African Climate Foundation
            </Link>
            <Link
              href="https://impactamplifier.co.za"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              sx={{
                display: 'block',
                color: 'rgba(255,255,255,0.7)',
                fontSize: '0.875rem',
                fontWeight: 700,
                transition: 'color 0.2s ease',
                '&:hover': { color: '#B87333' },
              }}
            >
              Impact Amplifier
            </Link>
          </Grid>
        </Grid>

        <Divider sx={{ borderColor: 'rgba(255,255,255,0.12)', my: 3.5 }} />

        <Typography variant="body2" sx={{ color: 'rgba(255,247,234,0.82)', textAlign: 'center', fontSize: '0.8rem', fontWeight: 500 }}>
          &copy; {new Date().getFullYear()} Future of Farm Food Library. All rights reserved.
        </Typography>
      </Box>
    </Box>
  )
}
